export default {
  title: "Recuperar senha",
  description: "Digite seu email para receber um link de recuperação de senha",
  emailLabel: "Email",
  submit: "Enviar link de recuperação",
  sending: "Enviando...",
  backToLogin: "Voltar para o login",
  emailSentTitle: "Email enviado!",
  emailSentDescription: "Se o email existir em nosso sistema, você receberá um link para redefinir sua senha",
  sentTo: "Link enviado para",
  checkSpam: "Verifique também sua pasta de spam se não encontrar o email na caixa de entrada",
  tryAnotherEmail: "Tentar outro email",
  // Proteção anti-abuso
  cooldownMessage: "Aguarde {{seconds}} segundos para tentar novamente",
  rateLimit: "Limite de tentativas excedido",
  rateLimitDescription: "Por motivos de segurança, você deve aguardar antes de tentar novamente",
  attemptsRemaining: "Tentativas restantes: {{attempts}}",
  captchaLabel: "Verificação de segurança",
  captchaRequired: "Por favor, complete a verificação de segurança",
  tooManyAttempts: "Muitas tentativas detectadas"
} as const;
